module.exports = __webpack_public_path__ + "5f8ed5931cc36c6186e4026e6b0495aa.pdf";